const liveEnv = process.env.REACT_APP_ENV || 'development';
const awsConfig = require(`./${liveEnv}`);
export default awsConfig.default;
